// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3LA_e","sendOtp":"AuthorizeToLogin_sendOtp__2VEZD"};